export default "__VITE_ASSET__DdYc5XSR__"